/* eslint-disable no-unused-vars */
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import DateTime from "react-datetime";
import { Link } from "react-router-dom";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";

import {
	useGetAllDashboard,
	useGetOrdersDashboard,
	useGetRevenueDashboard,
} from "../../../queryHooks/usePayouts";
import qs from "qs";
import { FiRefreshCw } from "react-icons/fi";
import { URL } from "../../../constants/URL";

Chart.register(CategoryScale);
//	Pre-defined values

const borderColor = [...Array.from({ length: 12 }, () => "#39DA8A")];
const values = [...Array.from({ length: 12 }, (_, x) => x + 1)];
const initialState = {
	year: new Date().getFullYear(),
	max: 10,
	stepSize: 4,
	values,
};

const labels = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

//  Component starts
const Dashboard = () => {
	const [orderFilter, setOrderFilter] = useState({
		filter_date: {
			start_date: "",
			end_date: "",
		},
	});

	const [revenueFilter, setRevenueFilter] = useState({
		filter_date: {
			start_date: "",
			end_date: "",
		},
	});

	const [startdaterevenueErrors, setStartRevenueErrors] = useState("");
	const [enddaterevenueErrors, setEndRevenueErrors] = useState("");
	const [startdateordersErrors, setStartOrdersErrors] = useState("");
	const [enddateordersErrors, setEndOrdersErrors] = useState("");

	const [dashboardData, setDashboardData] = useState(null);
	//  Orders
	const [orders, setOrders] = useState(initialState);
	//  Payments
	const [payments, setPayments] = useState(initialState);
	const [totalRevenue, setTotalRevenue] = useState(0);
	const [totalRevenueBar, setTotalRevenueBar] = useState(0);
	const [totalOrders, setTotalOrders] = useState(0);
	const [totalOrdersBar, setTotalOrdersBar] = useState(0);

	const convertData = (responseData) => {
		let convertedResponse = responseData?.map((monthData) => {
			return { ...monthData };
		});
		return convertedResponse;
	};

	const { max, stepSize, values } = orders;

	const { data: dataGetDashboard } = useGetAllDashboard();

	const { data: dataGetOrders } = useGetOrdersDashboard(
		qs.stringify(orderFilter.filter_date.end_date === "" ? "" : orderFilter)
	);

	const { data: dataGetRevenue } = useGetRevenueDashboard(
		qs.stringify(revenueFilter.filter_date.end_date === "" ? "" : revenueFilter)
	);

	useEffect(() => {
		if (dataGetOrders && dataGetOrders.status === "success") {
			const data = convertData(dataGetOrders?.data?.monthly_data);
			getProperGraphData(data, "orders");
			setTotalOrdersBar(
				dataGetOrders?.data?.aggregate_monthly_data?.successful_orders
			);
		}
	}, [dataGetOrders, orderFilter.filter_date.end_date]);

	useEffect(() => {
		if (dataGetRevenue && dataGetRevenue.status === "success") {
			const data = convertData(dataGetRevenue?.data?.monthly_data);
			getProperGraphData(data, "payments");
			setTotalRevenueBar(
				dataGetRevenue?.data?.aggregate_monthly_data?.net_amount
			);
		}
	}, [dataGetRevenue]);

	useEffect(() => {
		if (dataGetDashboard && dataGetDashboard.status === "success") {
			let respData = dataGetDashboard?.data?.admin_data;
			setDashboardData({
				totalRevenue: respData?.total_revenue,
				opaCommission: respData?.total_platform_fee,
				totalPayouts: respData?.total_payouts,
				restaurants: respData?.total_restaurants,
				orders: respData?.total_successful_orders,
				users: respData?.total_users,
			});
			setTotalRevenue(respData?.total_revenue);
			setTotalOrders(respData?.total_orders);
		}
	}, [dataGetDashboard]);

	/******************************************************************************************
    @Purpose    :   To get the proper graph data
    *******************************************************************************************/
	const getProperGraphData = (apiData, type) => {
		const result = Array.from({ length: 12 }, (_, x) => {
			const entity = apiData.find((o) => o.month === x + 1);
			if (isEmpty(entity)) return 0;
			if (type === "orders") {
				return entity.successful_orders;
			} else {
				return entity.net_amount;
			}
		});

		const maxValue = Math.max(...result) ? Math.max(...result) : 4;
		const stepSize = Math.ceil(maxValue / 4);
		const remainder = maxValue % stepSize;
		const updateMaxValue = remainder ? maxValue + remainder : maxValue;
		if (type === "orders") {
			setOrders({ ...orders, max: updateMaxValue });
			setOrders({ ...orders, stepSize: stepSize });
			setOrders({ ...orders, values: result });
		} else {
			setPayments({ ...payments, max: updateMaxValue });
			setPayments({ ...payments, stepSize: stepSize });
			setPayments({ ...payments, values: result });
		}
	};

	const ordersData = {
		labels,
		datasets: [
			{
				borderColor,
				label: "Gifts",
				data: orders.values,
				backgroundColor: "#26C1C9",
				pointBorderColor: "#26C1C9",
				pointBackgroundColor: "#26C1C9",
			},
		],
	};

	const ordersOptions = {
		display: true,
		responsive: true,
		legend: { display: false },
		scales: {
			yAxes: [
				{ ticks: { min: 0, max: orders.max, stepSize: orders.stepSize } },
			],
		},
	};

	//  Payments
	const paymentsData = {
		labels,
		datasets: [
			{
				borderColor,
				label: "Revenue",
				backgroundColor: "#26C1C9",
				data: payments.values,
				pointBorderColor: "#26C1C9",
				pointBackgroundColor: "#26C1C9",
			},
		],
	};

	const paymentsOptions = {
		display: true,
		responsive: true,
		legend: { display: false },
		scales: {
			yAxes: [
				{ ticks: { min: 0, max: payments.max, stepSize: payments.stepSize } },
			],
		},
	};

	/**
	 *
	 * @param {*} date
	 * @param {*} type
	 */
	const handleOrdersDateChange = (date, type) => {
		let _filter = { ...orderFilter };
		_filter.filter_date[type] =
			type === "start_date"
				? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
				: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
		if (_filter.filter_date["start_date"] == "") {
			setStartOrdersErrors("Please select start date");
			orderFilter.filter_date.end_date = "";
		} else {
			_filter.filter_date[type] =
				type === "start_date"
					? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
					: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
			setOrderFilter(_filter);
			setStartOrdersErrors("");
		}

		if (_filter.filter_date["end_date"]) {
			if (_filter.filter_date["start_date"] > _filter.filter_date["end_date"]) {
				setEndOrdersErrors("End date must be greater than start date");
				orderFilter.filter_date.end_date = "";
			} else {
				_filter.filter_date[type] =
					type === "start_date"
						? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
						: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
				setOrderFilter(_filter);
				setEndOrdersErrors("");
			}
		}
	};

	/**
	 *
	 * @param {*} date
	 * @param {*} type
	 */
	const handleRevenueDateChange = (date, type) => {
		let _filter = { ...revenueFilter };
		_filter.filter_date[type] =
			type === "start_date"
				? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
				: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
		if (_filter.filter_date["start_date"] == "") {
			setStartRevenueErrors("Please select start date");
			_filter.filter_date.end_date = "";
		} else {
			// _filter.value[type] = moment(date).format("YYYY-MM-DD HH:mm:ss");
			_filter.filter_date[type] =
				type === "start_date"
					? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
					: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
			setRevenueFilter(_filter);
			setStartRevenueErrors("");
		}

		if (_filter.filter_date["end_date"]) {
			if (_filter.filter_date["start_date"] > _filter.filter_date["end_date"]) {
				setEndRevenueErrors("End date must be greater than start date");
				_filter.filter_date.end_date = "";
			} else {
				_filter.filter_date[type] =
					type === "start_date"
						? new Date(new Date(date).setHours(0, 0, 0)).toISOString()
						: new Date(new Date(date).setHours(23, 59, 59)).toISOString();
				setRevenueFilter(_filter);
				setEndRevenueErrors("");
			}
		}
		// _filter.value[type] = moment(date).format("YYYY-MM-DD HH:mm:ss");
	};

	const handleClearOrderFilter = () => {
		setOrderFilter({
			filter_date: {
				start_date: "",
				end_date: "",
			},
		});
	};

	const handleClearRevenueFilter = () => {
		setRevenueFilter({
			filter_date: {
				start_date: "",
				end_date: "",
			},
		});
	};

	return (
		<div className="card">
			<div className="content-wrapper mb-5">
				<div className="row animated fadeIn dashboard-box">
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card ml-0">
							<Link to={URL.onboarderedUsers}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center ">
											<div className="dashboard-total">
												<i className="bx bxs-group" />
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.users}
												</h3>
												<h4 className="card-text">User</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card">
							<Link to={URL.restaurants}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center">
											<div className="dashboard-total">
												<i className="bx bxs-group" />
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.restaurants}
												</h3>
												<h4 className="card-text">Restaurant</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card">
							<Link to={URL.transactions}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center">
											<div className="dashboard-total">
												<i className="bx bxs-bar-chart-square" />
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.opaCommission
														? `$ ${dashboardData?.opaCommission} `
														: "$ 0"}
												</h3>
												<h4 className="card-text">Opa Commission</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card mr-0 md-mr-10-ml-0">
							<Link to={URL.giftOrders}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center">
											<div className="dashboard-total">
												<i className="bx bx-package"></i>
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.orders}
												</h3>
												<h4 className="card-text">Total Gifts</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card ml-0 md-ml-10">
							<Link to={URL.transactions}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center">
											<div className="dashboard-total">
												<i className="bx bx-receipt"></i>
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.totalRevenue
														? `$ ${dashboardData?.totalRevenue}`
														: " $ 0"}
												</h3>
												<h4 className="card-text">Total Revenue</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4 mb-5">
						<div className="card ml-0 md-ml-10">
							<Link to={URL.payoutsHistory}>
								<div className="card-body">
									<div className="clearfix">
										<div className="d-flex align-item-center">
											<div className="dashboard-total">
												<i className="bx bx-receipt"></i>
											</div>
											<div className="ml-3">
												<h3 className="card-title mb-1">
													{dashboardData?.totalPayouts
														? `$ ${dashboardData?.totalPayouts}`
														: "$ 0"}
												</h3>
												<h4 className="card-text">Total Payouts</h4>
											</div>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12 col-lg-6 mb-0 mb-md-5">
					<div className="bar-box">
						<button
							type="button"
							className="float-right mb-3 clear-filter"
							onClick={handleClearOrderFilter}
							data-toggle="tooltip"
							data-placement="top"
							title="Reset Filter"
						>
							<FiRefreshCw size={20} />
						</button>
						<div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-4">
							<h3 className="mb-0">Total Gifts</h3>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<label className="text-left">From</label>
										<DateTime
											inputProps={{ placeholder: "Start Date" }}
											timeFormat={true}
											value={orderFilter.filter_date.start_date}
											onChange={(date) =>
												handleOrdersDateChange(date, "start_date")
											}
											renderInput={(props) => {
												return (
													<input
														{...props}
														value={
															orderFilter.filter_date.start_date
																? props.value
																: ""
														}
													/>
												);
											}}
											isValidDate={(current) => new Date(current) <= new Date()}
										/>
										<span className="text-danger mb-2">
											{startdateordersErrors !== ""
												? `* ${startdateordersErrors}`
												: ""}
										</span>
									</div>
									<div className="col-md-6">
										<label className="text-left">To</label>
										<DateTime
											inputProps={{ placeholder: "End Date" }}
											timeFormat={true}
											value={orderFilter.filter_date.end_date}
											onChange={(date) =>
												handleOrdersDateChange(date, "end_date")
											}
											renderInput={(props) => {
												return (
													<input
														{...props}
														value={
															orderFilter.filter_date.end_date
																? props.value
																: ""
														}
													/>
												);
											}}
											closeOnSelect={true}
											isValidDate={(current) => new Date(current) <= new Date()}
										/>
										<span className="text-danger mb-2">
											{enddateordersErrors !== ""
												? `* ${enddateordersErrors}`
												: ""}
										</span>
									</div>
								</div>
							</div>
						</div>
						<h3 className="revenue-title">
							Total Gifts: {totalOrdersBar == null ? "0" : `${totalOrdersBar}`}
						</h3>
						<Bar data={ordersData} options={ordersOptions} />
					</div>
				</div>
				<div className="col-md-12 col-lg-6">
					<div className="bar-box">
						<button
							type="button"
							className="float-right mb-3 clear-filter"
							onClick={handleClearRevenueFilter}
							data-toggle="tooltip"
							data-placement="top"
							title="Reset Filter"
						>
							<FiRefreshCw size={20} />
						</button>
						<div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-4">
							<h3 className="mb-0">Payments</h3>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<label className="text-left">From</label>
										<DateTime
											inputProps={{ placeholder: "Start Date" }}
											timeFormat={true}
											value={revenueFilter.filter_date.start_date}
											onChange={(date) =>
												handleRevenueDateChange(date, "start_date")
											}
											renderInput={(props) => {
												return (
													<input
														{...props}
														value={
															revenueFilter.filter_date.start_date
																? props.value
																: ""
														}
													/>
												);
											}}
											closeOnSelect={true}
											isValidDate={(current) => new Date(current) <= new Date()}
										/>
										<span className="text-danger mb-2">
											{startdaterevenueErrors !== ""
												? `* ${startdaterevenueErrors}`
												: ""}
										</span>
									</div>
									<div className="col-md-6">
										<label className="text-left">To</label>
										<DateTime
											inputProps={{ placeholder: "End Date" }}
											timeFormat={true}
											value={revenueFilter.filter_date.end_date}
											onChange={(date) =>
												handleRevenueDateChange(date, "end_date")
											}
											renderInput={(props) => {
												return (
													<input
														{...props}
														value={
															revenueFilter.filter_date.end_date
																? props.value
																: ""
														}
													/>
												);
											}}
											closeOnSelect={true}
											isValidDate={(current) => new Date(current) <= new Date()}
										/>
										<span className="text-danger mb-2">
											{enddaterevenueErrors !== ""
												? `* ${enddaterevenueErrors}`
												: ""}
										</span>
									</div>
								</div>
							</div>
						</div>
						<h3 className="revenue-title">
							Total Revenue:{" "}
							{totalRevenueBar == null ? "$ 0" : `$ ${totalRevenueBar}`}
						</h3>
						<Bar data={paymentsData} options={paymentsOptions} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
